import { z } from 'zod';
import { baseTaskSchema } from '../schema.base.js';
import { checkboxMediaInput } from '../select-answers.checkbox/input.media.js';

const selectAnswersMarkElementTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("SelectAnswers"),
  answerType: z.literal("MarkElement"),
  answerOptions: z.array(checkboxMediaInput.schema)
}).transform(({
  answerOptions,
  ...rest
}) => ({
  ...rest,
  //
  // NB: MarkElements are visually 1:1 the same as the RadioButton task in
  // forced stacked mode. See ADO #114500
  //
  answerType: "RadioButton",
  content: answerOptions.map((it, index) => checkboxMediaInput.postprocessSchemaInput(it, {
    taskId: rest.id,
    index
  })),
  settings: {
    orientation: "Horizontal"
  }
}));

export { selectAnswersMarkElementTaskSchema };
//# sourceMappingURL=_schema.mark-element.js.map
